<template>
    <div class="card st-framework-card">

        <div class="card-header">
            <table style="border-collapse: collapse; width: 100%;">
                <tbody>
                <tr>
                    <td style="margin: 0; padding: 0 0 0 1rem; width: 50px;">
                        <font-awesome-icon :icon="icon" size="sm"/>
                    </td>
                    <td style="text-align: center;">
                        {{ $i18n.tc('translations.' + name, 2) }}
                    </td>
                    <td style="width: 50px;"/>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card-body" v-if="pageLoaded">
            <div class="card-columns">

                <!-- Document -->

                <div class="card">
                    <div class="card-header" style="text-align: center;">
                        {{ $i18n.tc('translations.Estimate', 2) }} / {{ $i18n.tc('translations.Quote', 2) }} / {{ $i18n.tc('translations.Order', 2) }}
                    </div>
                    <div class="card-body st-fadein-content">
                        <RecordForm :fields="fields.documentFields"
                                    :formErrors="documentFormErrors" :generalError="documentGeneralError"
                                    :languages="languages" :userLanguage="userLanguage"
                                    v-on:model-data="onDocumentData"/>
                        <div class="container-fluid mt-3 p-0">
                            <div class="row">
                                <div class="col">
                                </div>
                                <div class="col-auto">
                                    <template v-for="(action,index) in actions.documentActions">
                                        <DropDownAction :key="action.name + '-' + index" :action="action"
                                                        v-on:download-event="downloadDocument($event, documentData)"
                                                        v-if="action.type === 'DROPDOWN' && action.placement === 'TABLEFOOTERRIGHT'"/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Project -->

                <div class="card">
                    <div class="card-header" style="text-align: center;">
                        {{ $i18n.tc('translations.Project', 2) }}
                    </div>
                    <div class="card-body st-fadein-content">
                        <RecordForm :fields="fields.projectFields"
                                    :formErrors="projectFormErrors" :generalError="projectGeneralError"
                                    :languages="languages" :userLanguage="userLanguage"
                                    v-on:model-data="onProjectData"/>
                        <div class="container-fluid mt-3 p-0">
                            <div class="row">
                                <div class="col">
                                </div>
                                <div class="col-auto">
                                    <template v-for="(action,index) in actions.projectActions">
                                        <DropDownAction :key="action.name + '-' + index" :action="action"
                                                        v-on:download-event="downloadProject($event, projectData)"
                                                        v-if="action.type === 'DROPDOWN' && action.placement === 'TABLEFOOTERRIGHT'"/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Inventory -->

                <div class="card">
                    <div class="card-header" style="text-align: center;">
                        {{ $i18n.t('translations.Inventory Usage') }}
                    </div>
                    <div class="card-body st-fadein-content">
                        <RecordForm :fields="fields.inventoryFields"
                                    :formErrors="inventoryFormErrors" :generalError="inventoryGeneralError"
                                    :languages="languages" :userLanguage="userLanguage"
                                    v-on:model-data="onInventoryData"/>
                        <div class="container-fluid mt-3 p-0">
                            <div class="row">
                                <div class="col">
                                </div>
                                <div class="col-auto">
                                    <template v-for="(action,index) in actions.inventoryActions">
                                        <DropDownAction :key="action.name + '-' + index" :action="action"
                                                        v-on:download-event="downloadInventory($event, inventoryData)"
                                                        v-if="action.type === 'DROPDOWN' && action.placement === 'TABLEFOOTERRIGHT'"/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import DropDownAction from "@/components/actions/DropDownAction";
import FileDownload from "@/mixins/FileDownload";
import RecordForm from "@/components/forms/RecordForm";

export default {
    name: 'Reporting',
    components: {
        DropDownAction,
        RecordForm,
    },
    props: ['name', 'icon', 'api', 'state', 'userLanguage', 'languages'],
    mixins: [FileDownload],
    data() {
        return {
            pageLoaded: false,
            actions: null,
            fields: null,
            documentData: null,
            inventoryData: null,
            projectData: null,
            documentFormErrors: null,
            documentGeneralError: null,
            projectFormErrors: null,
            projectGeneralError: null,
            inventoryFormErrors: null,
            inventoryGeneralError: null,
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        downloadDocument(choice, data) {
            this.state.loading = true;

            this.documentFormErrors = null;
            this.documentGeneralError = null;

            this.$http.post(choice.api, data, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                [this.documentFormErrors, this.documentGeneralError] = this.handleFormErrors(error);
                this.state.loading = false;
            });
        },
        downloadInventory(choice, data) {
            this.state.loading = true;

            this.inventoryFormErrors = null;
            this.inventoryGeneralError = null;

            this.$http.post(choice.api, data, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                [this.inventoryFormErrors, this.inventoryGeneralError] = this.handleFormErrors(error);
                this.state.loading = false;
            });
        },
        downloadProject(choice, data) {
            this.state.loading = true;

            this.projectFormErrors = null;
            this.projectGeneralError = null;

            this.$http.post(choice.api, data, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                [this.projectFormErrors, this.projectGeneralError] = this.handleFormErrors(error);
                this.state.loading = false;
            });
        },
        fetchData() {
            this.$http.get(this.api + '/manage', {}).then((res) => {
                this.actions = res.data.actions;
                this.fields = res.data.fields;
                this.state.loading = false;
                this.pageLoaded = true;
            }).catch((error) => {
                console.log("Reporting:fetchData():error:", error);
            });
        },
        handleFormErrors(error) {
            let formErrors = null;
            let generalError = null;

            if (error.response?.status === 422) {
                formErrors = error.response.data.errors;
            } else {
                if (error.response?.status) {
                    generalError = error.response.status + ': ' + error.response.statusText;
                } else {
                    generalError = error.code + ': ' + error.message;
                }
                console.log("Reporting:handleFormErrors():error:", error);
            }

            return [formErrors, generalError];
        },
        onDocumentData(data) {
            this.documentData = data;
        },
        onInventoryData(data) {
            this.inventoryData = data;
        },
        onProjectData(data) {
            this.projectData = data;
        },
    }
}
</script>

<style scoped>
</style>